import React, { useState } from "react"
import AiStatsGrid from "./components/AiStatsGrid"
import TokenBreakdownCard from "./components/TokenBreakdownCard"
import UserManagement from "./components/UserManagement"
import QuotaModal from "./components/QuotaModal"
import { UserQuota } from "./types/ai-dashboard"
import PriceInfoCard from "./components/PriceInfoCard"
import { useAiDashboardData } from "./hooks/useAiDashboardData"

const AiAdminDashboardPage: React.FC = () => {
     const [selectedUser, setSelectedUser] = useState<UserQuota | null>(null)

     // Récupération de toutes les données et handlers via le hook personnalisé
     const {
          stats,
          top3,
          users,
          total,
          perPage,
          isLoading,
          search,
          page,
          filter,
          startDate,
          endDate,
          onSearchChange,
          onPageChange,
          onFilterChange,
          onDateChange,
          updateUserQuota,
     } = useAiDashboardData()

     return (
          <div className="bg-light min-vh-100 py-5">
               <div className="container">
                    <div className="mb-5">
                         <PriceInfoCard />
                    </div>

                    <div className="row mb-4 g-4 align-items-stretch">
                         <div className="col-lg-8">
                              <AiStatsGrid stats={stats} isLoading={isLoading} />
                         </div>
                         <div className="col-lg-4">
                              <TokenBreakdownCard stats={stats} isLoading={isLoading} />
                         </div>
                    </div>

                    <div className="row g-4">
                         <div className="col-12">
                              <UserManagement
                                   users={users}
                                   top3={top3}
                                   total={total}
                                   perPage={perPage}
                                   isLoading={isLoading}
                                   search={search}
                                   page={page}
                                   filter={filter}
                                   startDate={startDate}
                                   endDate={endDate}
                                   onSearchChange={onSearchChange}
                                   onPageChange={onPageChange}
                                   onFilterChange={onFilterChange}
                                   onDateChange={onDateChange}
                                   onManageQuota={setSelectedUser}
                              />
                         </div>
                    </div>

                    <QuotaModal user={selectedUser} onClose={() => setSelectedUser(null)} onSave={updateUserQuota} />
               </div>
          </div>
     )
}

export default AiAdminDashboardPage
